import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";

export const AdContainer = styled.div`
  ${setFullViewportWidthStyles()}
  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: block;
  }
`;

export const SearchContainer = styled.div`
  max-inline-size: 720px;
  margin-block-end: 60px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    margin-inline: 20%;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-inline: auto;
  }
`;

export const StyledAdSlot = styled(AdSlot)`
  padding-block: 20px;
`;
